
export default class SchedulesTimeFilter {
    static FILTER_1HOUR = 1;
    static FILTER_3HOUR = 3;
    static FILTER_8HOUR = 8;
    static FILTER_6HOUR = 6;
    static FILTER_9HOUR = 9;
    static FILTER_12HOUR = 12;
    static FILTER_24HOUR = 24;
    static FILTER_TODAY = 'today';
    static FILTER_TOMORROW = 'tomorrow';
    static FILTER_ALL = null;

    static hoursfilter = null;
	static timeFilterTs = null;

    /**
     * Ritorna il valore attuale impostato per il filtro
     */
    static getCurrentFilter() {
        return this.hoursfilter;
    }

    /**
     * Ritorna una descrizione testuale del tipo di filtro attualmente applicato
     * @returns {string}
     */
    static getFilterDescription() {
        switch (this.hoursfilter) {
            case this.FILTER_1HOUR:
            case this.FILTER_3HOUR:
            case this.FILTER_8HOUR:
            case this.FILTER_6HOUR:
            case this.FILTER_9HOUR:
            case this.FILTER_12HOUR:
            case this.FILTER_24HOUR:
                return 'Prossime '+ this.hoursfilter +' ore'; // TODO Non è traducibile
            case this.FILTER_TODAY:
                return 'Oggi'; // TODO Non è traducibile
            case this.FILTER_TOMORROW:
                return 'Domani'; // TODO Non è traducibile
            case this.FILTER_ALL:
                return 'Tutto'; // TODO Non è traducibile
            default:
                return '';
        }
    }

    /**
     * Imposta il filtro orario desiderato per la visualizzazione di manifestazioni ed eventi
     * @param hours
     */
    static setTimeFilter(hours) {
        switch (hours) {
            case this.FILTER_1HOUR:
            case this.FILTER_3HOUR:
            case this.FILTER_8HOUR:
            case this.FILTER_6HOUR:
            case this.FILTER_9HOUR:
            case this.FILTER_12HOUR:
            case this.FILTER_24HOUR:
            case this.FILTER_TODAY:
            case this.FILTER_TOMORROW:
            case this.FILTER_ALL:
                this.hoursfilter = hours;
                break;
            default:
                this.hoursfilter = this.FILTER_ALL;
                break;
        }
		if (hours == this.FILTER_TODAY) {
			this.timeFilterTs = Math.floor(new Date(getDateString(new Date()) +' 23:59:59').getTime()/1000)
		} else if (hours == this.FILTER_TOMORROW) {
			this.timeFilterTs = Math.floor(new Date(getDateString(new Date(Date.now() + 24*60*60*1e3)) +' 23:59:59').getTime()/1000)
		} else {
			this.timeFilterTs = null;
		}
    }

    /**
     * Verifica se il timestamp unix in secondi fornito in ingresso rientra
     * nel filtro temporale impostato
     * @param time
     * @returns {boolean}
     */
    static isTimeAllowed(time) {
        if (!!this.hoursfilter) {
            if (!isNaN(this.hoursfilter)) {

                const now = Math.floor(new Date().getTime() / 1000);
                return time <= now + (this.hoursfilter * 3600);

            } else if(this.hoursfilter === this.FILTER_TODAY || this.hoursfilter === this.FILTER_TOMORROW) {

                const todayEndTime = this.timeFilterTs;
                return time <= todayEndTime;

            }
        }

        return true;
    }

    /**
     * Gli si può passare un oggetto sport, campionato o manifestazione
     * e ritorna un valore bool per indicare se rientra nel filtro orario impostato
     * @param schedule
     * @returns {boolean}
     */
    static isScheduleAllowed(schedule) {
        return this.isTimeAllowed(Math.floor(schedule['next-event'] / 1000));
    }

    /**
     * Accetta in ingresso un oggetto rappresentante un evento giocabile
     * e ritorna un valore booleano che indica se rientra nei criteri di ricerca
     * impostati
     * @param event
     * @returns {boolean}
     */
    static isEventAllowed(event) {
        return this.isTimeAllowed(event.date);
    }
}

function getDateString(date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    return yyyy +'-'+ mm +'-'+ dd;
}